import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";

const NONE = "__none";

export const DocumentSelect = ({ workspaceId, value, onChange, testId = "document-select" }) => {
  const [docs, setDocs] = useState([]);
  useEffect(() => { api.get(`/workspaces/${workspaceId}/documents`).then(({ data }) => setDocs(data.documents)).catch(() => {}); }, [workspaceId]);
  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? null : v)}>
      <SelectTrigger data-testid={testId} className="h-11"><SelectValue /></SelectTrigger>
      <SelectContent className="max-h-72">
        <SelectItem value={NONE}>No linked document</SelectItem>
        {docs.map((d) => <SelectItem key={d.id} value={d.id}>{d.original_filename}</SelectItem>)}
      </SelectContent>
    </Select>
  );
};
